import React from 'react'
import { IoSearchOutline } from 'react-icons/io5'

const TableSearch = ({ ...props }) => {

    const handleSubmit = () => {

    }

    return (
        <div className="search-box">
            <form onSubmit={handleSubmit}>
                <div className="search-input">
                    <input type="search" placeholder="Search" className="form-control form-control-sm" {...props} />
                    <button>
                        <IoSearchOutline />
                    </button>
                </div>
            </form>
        </div>
    )
}

export default TableSearch
